import React, { useEffect, useState, useRef } from "react";
import { Form, Icon, Button } from "semantic-ui-react";
import { Label, Toast } from "reactstrap";
import { LogoProv, background, logo, agj, agn, bij, jsw, jsn, muj, mrj, tgr, eye_off, eye_open } from "../assets/images";
import { BASE_URL } from "../constants";
import axios from "axios";
import { sha256 } from 'js-sha256';
import ReCAPTCHA from 'react-google-recaptcha'
import { toast } from "react-toastify";

export const Login = () => {
  const recaptchaRef = React.createRef();
  const [forgot, setForgot] = useState(true);
  const [data, setData] = useState({});
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const handleChange = (event) => {
    setData({
      ...data,
      [event.target.name]: event.target.value,
    });
  };

  const [checked, setChecked] = React.useState(false);
  const handleChangecheck = () => {
    setChecked(!checked);
  };
  const [showPwd, setShowPwd] = useState(false);

  const handleLogin = (e) => {
    e.preventDefault();
    const token = recaptchaRef.current.getValue();
    if (token) {
      const request = {
        email: data.email,
        password: sha256(data.password)
      }

      setLoading(true);
      axios
        .post(`${BASE_URL}/auth/login`, request)
        .then((response) => {
          const user = { ...response.data };
          delete user.token;
          localStorage.setItem("token", response.data.token);
          localStorage.setItem("user", JSON.stringify(user));
          window.location.reload();
          setLoading(false);
        })
        .catch((err) => {
          if (!err.response) setError("Internet offline");
          else setError(err.response.data.message);
          setLoading(false);
        });
    } else {
      setError("Please verify that you are not a robot");
    }

  };

  if (localStorage.getItem("token")) {
    window.location.replace("/");
  }

  return (
    <div className="d-flex w-100 justify-content-center align-items-center">
      <div className="login-bg">
        <div className="bg"> &nbsp;</div>
        <img src={background} alt="" />
      </div>
      <div className="card border-0 login py-4">

        <div>
          <div className="container">
            {forgot ? (
              <Form className="" size="large" action="/" onSubmit={handleLogin}>
                <div className="d-flex justify-content-center align-items-center">
                  <img
                    className="mx-4 logo--login display: block; margin: 0 auto"
                    src={logo}
                    alt="Provinsi Jawa Barat"
                  />
                </div>
                <span>
                  <h2 className="text-muted text-center mt-2">SIMOLEK</h2>
                </span>
                <span>
                  <h5 className="text-muted text-center mb-3 mt-2">SIstem MOnitoring Laporan Evaluasi Kinerja</h5>
                </span>

                {/* <Label className="font-weight-bold mb-3">Masuk</Label> */}
                <Form.Input
                  fluid
                  icon="user"
                  iconPosition="left"
                  placeholder="E-mail address"
                  name="email"
                  onChange={handleChange}
                  required
                />
                {/* <Form.Input
                fluid
                icon="lock"
                iconPosition="left"
                placeholder="Password"
                name="password"
                type="password"
                onChange={handleChange}
                required
              /> */}
                <Form.Input
                  name="password"
                  placeholder="Password"
                  type={showPwd ? "text" : "password"}
                  icon="lock"
                  iconPosition="left"
                  onChange={handleChange}
                  required
                />
                <div class="form-check">
                  <input className="form-check-input"
                    type="checkbox"
                    checked={showPwd ? "Hide password" : checked}
                    onChange={handleChangecheck}
                    onClick={() => setShowPwd(prevState => !prevState)}
                  />
                  <label className="form-check-label">Show Password</label>
                </div>
                <div style={{
                  display: "flex",
                  alignContent: "center",
                  justifyContent: "center",
                }}>
                  <ReCAPTCHA ref={recaptchaRef} sitekey={process.env.REACT_APP_SITE_KEY} />

                </div>


                {error && <p className="text--caption_red mb-4">{error}</p>}
                <Button className="mt-4 w-100" color="green" loading={loading}>
                  MASUK
                </Button>

                <Button
                  onClick={() => setForgot(!forgot)}
                  type="button"
                  className="pl-0 border-0 bg-white text-primary"
                >
                  Lupa password
                </Button>
              </Form>

            ) : (
              <Form className="" size="large" action="/login">
                <Button
                  type="button"
                  onClick={() => setForgot(!forgot)}
                  className="bg-white pl-0"
                  color="blue"
                  style={{ color: "black" }}
                >
                  <Icon name="arrow left" /> Back
                </Button>
                <h3 className="mb-0">Lupa Kata Sandi</h3>
                <p className="text-muted mt-2" style={{ fontSize: "14px" }}>
                  Silahkan masukkan email Anda. Anda akan menerima tautan untuk
                  membuat kata sandi baru melalui email.
                </p>

                <Form.Input
                  fluid
                  icon="user"
                  iconPosition="left"
                  placeholder="E-mail address"
                  required
                />

                <Button className="mt-4 w-100" color="green">
                  KIRIM
                </Button>
              </Form>
            )}
          </div>
          <div className="container justify-content-center align-items-center mb-2">
            <img width="50"
              className="mx-3"
              src={agj}
              alt="AGR"
            />
            <img width="50"
              className="mx-3"
              src={agn}
              alt="AGN"
            />
            <img width="50"
              className="mx-3"
              src={bij}
              alt="BIJ"
            />
            <img width="50"
              className="mx-3"
              src={jsw}
              alt="JSW"
            /><img width="50"
              className="mx-3"
              src={jsn}
              alt="JSN"
            />
            <img width="50"
              className="mx-3"
              src={mrj}
              alt="MRJ"
            />
            <img width="50"
              className="mx-3"
              src={muj}
              alt="MUJ"
            />
            <img width="50"
              className="mx-3"
              src={tgr}
              alt="TGR"
            />
          </div>
          <h6 className="text-center mb-3">
            Copyright © {new Date().getFullYear()} Pemerintah Provinsi Jawa Barat
          </h6>
          <div className="d-flex align-items-center">
            <img
              className="mx-4"
              src={LogoProv}
              alt="Provinsi Jawa Barat"
              width="55" height="60"
            />
            <span>
              <h6 className="text-muted ">BIRO BUMD, INVESTASI <br /> dan ADMINISTRASI PEMBANGUNAN</h6>
              <p className="text-muted mt-2">Provinsi Jawa Barat</p>
            </span>
          </div>
        </div>

      </div>
    </div>

  );
};
